import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { APP_ORIGIN } from "../lib/appBase";

export const NOT_FOUND_TITLE = "Page not found · Solstack";
export const NOT_FOUND_DESCRIPTION =
  "That page doesn't exist on Solstack. Head back to the home page, the docs or the blog.";

const INDEXABLE = "index, follow";
const NOINDEX = "noindex, nofollow";

/**
 * Rendered for any URL the router doesn't know. The server already answers
 * such URLs with build/404.html and a real 404 status (see
 * scripts/prerender.js + wrangler.jsonc `not_found_handling`); this
 * component covers client-side navigations to a dead link, flipping the
 * robots meta to noindex for as long as it's mounted.
 */
export const NotFound = ({ className = "" }) => {
  useEffect(() => {
    const prevTitle = document.title;
    const robots = document.head.querySelector('meta[name="robots"]');
    const prevRobots = robots?.getAttribute("content");
    document.title = NOT_FOUND_TITLE;
    robots?.setAttribute("content", NOINDEX);
    return () => {
      document.title = prevTitle;
      robots?.setAttribute("content", prevRobots || INDEXABLE);
    };
  }, []);

  return (
    <section
      className={className}
      style={{
        maxWidth: 560,
        margin: "0 auto",
        padding: "96px 20px",
        textAlign: "center",
      }}
    >
      <p className="ds-eyebrow">404</p>
      <h1
        style={{
          fontFamily: "var(--font-display)",
          fontWeight: 800,
          letterSpacing: "-0.03em",
          fontSize: 40,
          lineHeight: 1.1,
          margin: "12px 0 10px",
        }}
      >
        Page not found
      </h1>
      <p style={{ color: "var(--text)", lineHeight: 1.5, marginBottom: 26 }}>
        {NOT_FOUND_DESCRIPTION}
      </p>
      <nav style={{ display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap" }}>
        <Link to="/" className="ds-btn ds-btn--secondary">
          Home
        </Link>
        <Link to="/academy" className="ds-btn ds-btn--secondary">
          Academy
        </Link>
        <Link to="/docs/overview" className="ds-btn ds-btn--secondary">
          Docs
        </Link>
        <Link to="/blog" className="ds-btn ds-btn--secondary">
          Blog
        </Link>
        <a href={APP_ORIGIN} rel="nofollow" className="ds-btn">
          Enter Solstack
        </a>
      </nav>
    </section>
  );
};
